/**
 * Created by forbiz on 2019-02-11.
 */

import 'slick-carousel';
import Swiper from 'swiper/dist/js/swiper'

const common = () => {
    const $window = $(window);
    const $document = $(document);
    const $htmlbody = $('html, body');
    const hdFn = {
        hdSlide( $target, opts ) {
            $($target).slick(opts);

            $('.slick-stop').on('click', function() {
                const $this = $(this);
                $this.addClass('hide').siblings('.slick-play').removeClass('hide');
                $($target).slick('slickPause');
            });
            
            $('.slick-play').on('click', function() {
                const $this = $(this);
                $this.addClass('hide').siblings('.slick-stop').removeClass('hide');
                $($target).slick('slickPlay');
            });
        }
    };

    // 레이어팝업 수정 - overflow:hidden 으로 변경, 레이어 팝업인 경우 슬릭 슬라이드 제어
    // 전체보기 버튼 수정
   
    /*
    - 레이어팝업 Event
        * 레이어팝업 Open
            버튼 Class - btn__modal-open / data-popup-name=".팝업 클래스명" / 레이어팝업에 동일 팝업 클래스명 추가
        * 레이어팝업 Close : 버튼 Class - btn__modal-close
    */
    const $btnClose = $('.btn__modal-close');
    const $header = $('.header');
    
    const modalPopUp = {
        popupOpen ( $target ) {
            const $popup = $('.'+ $target.data('popup-name'));
            const $popupInner = $popup.find('.modal');
            const $bannerHeight = $('.topBanner').css('display') == 'block' ? $('.topBanner').outerHeight(true) : 0;
                
            $('.hd__popup').hide();
            $popup.show();
            $htmlbody.css('overflow', 'hidden');

            if ( $popup.hasClass('designationDetail') ) {
                $('.designationDetail__inner').css('height', $('.designationDetail__wrap').height() - 64);
            }

            if ( $popup.hasClass('popup_search') ) {
                $htmlbody.css('overflow', '');
                $header.addClass('hd__header--showBg');

                if ( !$header.hasClass('fixed') ) $popupInner.css('top', 160 + $bannerHeight);
                else $popupInner.css('top', 60)
            }

            if ( $popup.hasClass('popup_filter') ) {
                $htmlbody.css('overflow', '');
                $popup.css('top', $('.filter').offset().top);
            }
        },
        popupClose ( $target ) {
            const $popup = $target.closest('.hd__popup');

            $popup.hide();
            $htmlbody.css('overflow', '');
            
            if ( $popup.hasClass('designationDetail') ) {
                $('.hd__popup.designationDetail .slider').slick('unslick');
            }
            
            if ( $popup.hasClass('popup_search')) {
                $header.removeClass('hd__header--showBg');
            }
        }
    }

    const modalEvent = () => {
        
        $document
            .on('click', ".btn__modal-open", function(e) {
                const $this = $(this);
                const loginCheck = $this.data('login');

                if ( loginCheck == 'n' ) {
                    modalPopUp.popupOpen($this);
                } else {
                    return false;
                } 

                e.preventDefault();
                e.stopPropagation()
            });

        $btnClose
            .on('click',  function(e) {
                const $this = $(this);
                
                modalPopUp.popupClose($this);

                e.preventDefault();
            });
    };

    // 미니카트
    const minicartOpen = () => {
        // const $optionArea = $('.option-area');        
        // const $btn = $('.btn-option');
        // const $dim = $('.layer-opacity');

        $document
            .on('click', ".btn-option .btn a", function(e) {
                const $optionArea = $(this).parents('.option-area');        
                const $btn = $(this).parents('.btn-option');
                const $dim = $optionArea.prev('.layer-opacity');

                $optionArea.addClass('open');
                $btn.addClass('btn-option--on');
                $dim.addClass('on');

                e.preventDefault();
            })
            .on('click', ".btn-option--on .btn a", function(e) {
                const $optionArea = $(this).parents('.option-area');        
                const $btn = $(this).parents('.btn-option');
                const $dim = $optionArea.prev('.layer-opacity');

                $optionArea.removeClass('open');
                $btn.removeClass('btn-option--on');
                $dim.removeClass('on');

                e.preventDefault();
            });
    };

    const reply = () => {
        $document
            .on('click', '.user__update__btn li:eq(0)', function(e) {
                const $this = $(this);
                
                $this.closest('.user__update__btn').siblings('.user__update').show().siblings('.box__list__txt').hide();

                e.preventDefault();
            });
    };

    // 컨텐츠별 수량 체크
    const amountCount = () => {
        $document
            .on('click', '.box__list .btn__count-down', function( e ) {
                const $this = $(this);
                const $target = $this.siblings('input');
                const _max_count = Number($target.attr('data-max-count'));

                menuAmount( $this, $target, _max_count );

                e.preventDefault();
            })       
            .on('click', '.box__list .btn__count-up', function( e ) {
                const $this = $(this);
                const $target = $this.siblings('input');
                const _max_count = Number($target.attr('data-max-count'));
    
                menuAmount( $this, $target, _max_count );

                e.preventDefault();
            })
            .on('keyup', '.box__list__count input', function( e ) {
                const $this = $(this);
                const _val = $this.val();
                const _max_count = Number($this.attr('data-max-count'));

                if ( _val === '0' ) {
                    $this.siblings('.btn__count-down').attr('disabled', true);
                    $this.removeClass('on').closest('.box__list__count').siblings('input[type="checkbox"]').prop('checked', false);
                } else if ( _val > _max_count ) {
                    alert('최대수량입니다.');
                    return $this.val(_max_count);
                }

                e.preventDefault();
            });

            const menuAmount = ( $button, $input, _maxCount ) => {
                let _val = Number($input.val());

                if ( $button.hasClass('btn__count-down') ) {
                    if ( 1 < _val ) {
                        _val -= 1;
                    } else {
                        $button.attr('disabled', true);
                        $input.removeClass('on').closest('.box__list__count').siblings('input[type="checkbox"]').prop('checked', false);
                        _val = 0;
                    }
                } else {
                    if ( _val < _maxCount ) {
                        $button.siblings('.btn__count-down').attr('disabled', false);
                        $input.addClass('on').closest('.box__list__count').siblings('input[type="checkbox"]').prop('checked', true);
                        _val += 1;
                    } else {
                        alert('최대수량입니다.');
                        _val = _maxCount;
                    }
                }

                $input.val(_val);
            };
    };

    const accordion = () => {
        $document
            .on('click', '.accordion__head', function(e) {
                const $this = $(this);
                const $accordion_cont = $this.closest('.accordion').children('.accordion__cont');

                if ( $this.hasClass('accordion__head--on') ) {
                    $accordion_cont.removeClass('accordion__cont--show').stop(true, true).slideUp();
                    $this.removeClass('accordion__head--on');

                    if($document.find('.hd__orderPayment').length == 1){
                        const $floating = $('.right-box');
                        const _st = $window.scrollTop();
                        const _contTotal = $('.orderPayment__inner').offset().top + $('.orderPayment__inner').outerHeight(true);
                        const _calc = _contTotal - (600 + $floating.children().height());

                        if ( _st >= $floating.offset().top - 112 && _calc > _st ) {
                            $floating.removeClass('absolute').addClass('fixed');
                        } else if ( _calc < _st && $floating.children().height() < $('.left-box').height() ) {
                            $floating.removeClass('fixed').addClass('absolute');
                        } else {
                            $floating.removeClass('fixed absolute');
                        }
                    }

                } else {
                    $accordion_cont.addClass('accordion__cont--show').stop(true, true).slideDown();
                    $this.addClass('accordion__head--on');
                }
                
                e.preventDefault();
            });
    };

    // 탭-콘텐츠 (탭메뉴 클릭시 해당 콘텐츠 노출)
    const tabContents = () => {

        $document
            .on('click', ".tab-menu__list", function(e) {
                const $this = $(this);
                const tab_name = $this.data('tab');
                const $tabContent = $('#' + tab_name);
                const noTab = $('body').attr('id').indexOf('idFind') == 0 || $('body').attr('id').indexOf('pwFind') == 0 || $('body').attr('id').indexOf('pwNewSetting') == 0;

                if ( !noTab ) {
                    $this.addClass('tab-menu__list--on').siblings().removeClass('tab-menu__list--on');
                    $tabContent.addClass('tab-content--show').siblings().removeClass('tab-content--show');

                    e.preventDefault();
                }
            });
    };

    // 지정일배송 & 정기식단 상세 슬라이드
    const item_slider = () => {
        if( $('#marketDetail').length > 0 ) {
            
            hdFn.hdSlide('.designationDetail .slider', {
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3000,                        // 5초에 한 번
                cssEase: 'linear',
                dots:true,
                appendDots: $(".slick-controller"),
                fade: true,
                infinite: true,
                speed: 500,                             // 루프 실행 속도
            });

            if ( $('.slider__list').length <= 1 ) {
                $('.slick-controller').hide();
            }
        }
    };

    const faq = () => {
        $document
            .on('click', '.faq .ques', function(e) {
                const $this = $(this);
                const $list = $this.closest('.box__list');

                if( !$list.hasClass('on') ) {
                    $('.faq .box__list').removeClass('on');
                    $this.closest('.box__list').siblings().find('.anws').stop().slideUp();
                    $list.addClass('on');
                    $this.siblings().stop().slideDown();
                } else {
                    $('.faq .box__list').removeClass('on');
                    $('.faq .anws').stop().slideUp();
                }

                e.preventDefault();
            });
    };
    
    // 초기화버튼 이벤트
    const textReset = () => {
        
        $document
            .on('click', ".btn-reset", function(e) {
                const $this = $(this);
                const $textInput = $this.siblings('.input__text');
                
                $textInput.val('');
                
                e.preventDefault();
            });
    };

    const myPage = () => {
        const myPageAccd = () => {
            $document
                .on('click', '.btn__accd', function(e) {
                    const $this = $(this);

                    if ( !$this.hasClass('on') ) {
                        $this.addClass('on').text('접어두기');
                        $this.closest('.box__list__sec').siblings('.boxInner').stop().slideDown();
                    } else {
                        $this.removeClass('on').text('펼쳐보기');
                        $this.closest('.box__list__sec').siblings('.boxInner').stop().slideUp();
                    }
    
                    e.preventDefault();
                });
        };

        const myPageCheck = () => {
            $document
                .on('change', '[name="orderListAll"]', function() {
                    const $this = $(this);
                    const $checkbox = $('[name="orderList"]');

                    if ( $this.is(':checked') ) $checkbox.prop('checked', true);
                    else $checkbox.prop('checked', false)
                });

            $document
                .on('change', '[name="orderList"]', function() {
                    const $all = $('[name="orderListAll"]');
                    const $checkbox = $('[name="orderList"]');
                    const _checked = $('[name="orderList"]:checked');

                    if ( $checkbox.length == _checked.length ) $all.prop('checked', true);
                    else $all.prop('checked', false);
                });
        };

        const fileLoad = () => {
            $document.on('change', '.input_file', function() {
                const $this = $(this);
                const _memory = Number($this.data('maxmemory-mb'));
                const _maxSize = _memory * 1024 * 1024; // MB 단위, KB일 경우 1024 한 개 제거
                const files = $this[0].files;
                let _thisSize = 0;
                
                if ( files && files[0] ) {
                    if ( files[0].type.match(/(jpg|jpeg|png)/i) != null ) {
                        let reader = new FileReader();
                        
                        _thisSize = files[0].size;
                        
                        if ( _thisSize >= _maxSize ) {
                            alert(`#{_memory}MB 미만의 파일만 등록 가능합니다.`);
                            errorFn($this);
                        } else {
                            $this.siblings('.del').show();
                            
                            reader.onload = function (e) {
                                $this.siblings('img').attr('src', e.target.result);
                            };
                        }
        
                        reader.readAsDataURL(files[0]);
                    } else {
                        alert('jpg 또는 png 파일만 등록 가능합니다.');
                        errorFn($this);
                    }
                } else {
                    errorFn($this);
                }
            });
            
            function errorFn ( $target ) {
                $target.siblings('.del').hide();
                $target.val('').siblings('img').attr('src', '/front_mo/images/img_comm_preview.png');
            }
        
            $document.on('click', '.btn_icon.del', function() {
                var $this = $(this);
                
                $this.hide();
                $this.siblings('img').attr('src', '/front_mo/images/img_comm_preview.png')
                .prev('input[type="file"]').val('');
            });
        };

        const accdCommon = () => {
            $document
                .on('click', '[data-accd]',function(e) {
                    const $this = $(this);

                    if ( !$this.closest('li').hasClass('on') ) {
                        $this.closest('li').addClass('on');
                        $this.next('[data-accd-open]').stop().slideDown();
                    } else {
                        $this.closest('li').removeClass('on');
                        $this.next('[data-accd-open]').stop().slideUp();
                    }

                    e.stopPropagation();
                    e.preventDefault();
                });
        };

        const myPageInit = () => {
            myPageAccd();
            myPageCheck();
            fileLoad();
            accdCommon();
        };

        myPageInit();
    };

    // 전체선택 체크박스 이벤트
    const allCheck = () => {
        $document
            .on('click', '[data-item-all]', function() {
                const $this = $(this);
                const $list = $('[data-item-list]');

                if ( $this.is(':checked') ) $list.prop('checked', true);
                else $list.prop('checked', false);
            });

        $document
            .on('click', '[data-item-list]', function() {
                const $all = $('[data-item-all]');
                const $list = $('[data-item-list]');
                const listCheck = $('[data-item-list]:checked');

                if ( $list.length == listCheck.length ) $all.prop('checked', true);
                else $all.prop('checked', false);
            });
    };

    const cardSlide = {
        slide: '',
        cardSlideStart() {
            this.slide = new Swiper('.greating-pay__sec.card .card__wrap', {
                centeredSlides: true,
                pagination: {
                    el: '.greating-pay__sec.card .swiper-pagination',
                    clickable: false,
                },
                slidesPerView: 1,
            });
        },
        cardSlideEnd() {
            this.slide.destroy();
            this.slide = '';
        }
    };
    
    const detailScroll = () => {
        function ieCheck () {
            const agent = navigator.userAgent.toLowerCase();
            
            if ( (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1) || (agent.indexOf("msie") != -1) ) {
                // ie일 경우
                return true;
            } else {
                // ie가 아닐 경우
                $('.tab-menu').addClass('fixed');
                return false;
            }
        };
        
        $('.designationDetail__inner').on('scroll', function() {
            if ( $('.designationDetail__sect.detail').position().top >= 30 ) {
                if ( ieCheck() ) {
                    $('.tab-menu').removeClass('ieFixed').css('top', 0);
                } else {
                    $('.tab-menu').removeClass('fixed');
                }
            } else {
                if ( ieCheck() ) {
                    // ie일 경우
                    $('.tab-menu').addClass('ieFixed').css('top', $('.close-area').offset().top - $window.scrollTop() + 30 );
                } else {
                    // ie가 아닐 경우
                    $('.tab-menu').addClass('fixed');
                }
            }
        });
    };

    // 일반배송 체크 이벤트
    const normalDelivery = () => {
        $document
            .on('click', '.normal-delivery', function() {
                const $this = $(this);
                const $checkInput = $this.children('input[name=deliveryNormal]');
                const $dawnDeliveryInfo = $('.dawnDelivery-info');
                const $dawnDeliveryDesc = $('.dawnDelivery--desc');
                const $dawnDeliveryDescType2 = $('.dawnDelivery--desc-type2');
                
                if( $checkInput.prop('checked') == true ) {
                    $this.addClass('on');
                    $dawnDeliveryInfo.hide();
                    $dawnDeliveryDesc.hide();
                    $dawnDeliveryDescType2.show();
                } else {
                    $this.removeClass('on');
                    $dawnDeliveryInfo.show();
                    $dawnDeliveryDesc.show();
                    $dawnDeliveryDescType2.hide();
                }
            });

        $document.on('change', '[name="inputinfo"]', function() {
            var $this = $(this);
    
            if ( $this.hasClass('inputYes') && $this.is(':checked') ) $('.applyOrderExchange__exDeliveryInfo01').show();
            else $('.applyOrderExchange__exDeliveryInfo01').hide();
        });
    };

    const accdMenu = () => {
        $document.on('click', '.notification .btn_accd', function(e) {
            const $this = $(this);

            if ( !$this.hasClass('on') ) $this.addClass('on').next().slideDown();
            else $this.removeClass('on').next().slideUp();

            e.preventDefault();
        });
    };

    const progressBar = () => {
        var $bar = $(".progress_wrap .progress_bar");
        var per = $bar.attr('data-value');
        var pre = $bar.attr('data-pre');
        var i = 0;

        if(pre != undefined){
            i = pre;
        }

        var intervalId = setInterval(function(){
            if(i < per){
               i++;
                $bar.css('width',i+'%');  
            } else if(i > per){
                i--;
                $bar.css('width',i+'%');
            } else{
               clearInterval(intervalId);  
            }    
        },10);

        $bar.attr('data-pre',per);
    };

    const myWelcomeBox = () => {
        if($('.myWelcome__slider li').length >= 5 ){
            hdFn.hdSlide('.myWelcome__slider ul', {
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1
            });
        }
    };

    const carefoodBtn = () => {
        if($('.carefood__wrap .btnBox').length == 1 ){
            
            $(window).on('scroll', function() {
                const $floating = $('.carefood__wrap .btn');
                const _st = $window.scrollTop();
                const _he = $window.height() - 92;
                const _contTotal = $('.carefood__wrap .btnBox').offset().top - _he;

                if ( _st >= _contTotal ) {
                    $floating.removeClass('fixed')
                }  else {
                    $floating.addClass('fixed');
                }
            });
        }
    };

    const introPopup = () => {
        const popWidth = $('.intro-popup .popup-slide').width();
        const popLength = $('.intro-popup .popup-slide .popup-list').length;

        $('.popup-slide').css({'width': popWidth});
            
        if (popLength > 1) {
            hdFn.hdSlide('.intro-popup .popup-slide', {
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 300,
                cssEase: 'linear'
            });
        }
    };

    const commonInit = () => {
        modalEvent();
        reply();
        amountCount();
        minicartOpen();
        accordion();
        tabContents();
        item_slider();
        faq();
        textReset();
        myPage();
        allCheck();
        //detailScroll();
        normalDelivery();
        accdMenu();
        window.progressBar = progressBar;
        window.hdFn = hdFn;
        window.cardSlide = cardSlide;
        window.modalPopUp = modalPopUp;
        window.introPopup = introPopup;
        myWelcomeBox();
        carefoodBtn();
    };

    commonInit();
};

export default common;